import { render, staticRenderFns } from "./TextFieldWithLabel.vue?vue&type=template&id=48bbf736&scoped=true&"
import script from "./TextFieldWithLabel.vue?vue&type=script&lang=js&"
export * from "./TextFieldWithLabel.vue?vue&type=script&lang=js&"
import style0 from "./TextFieldWithLabel.vue?vue&type=style&index=0&id=48bbf736&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bbf736",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VLabel,VRow,VTextField})
